import React, { useContext } from 'react';
import { ThemeContext } from '../context/theme-context';
import styles from '../styles/Experience.module.css';
import experienceData from '../data/experienceData';

function Experience() {
    const { theme } = useContext(ThemeContext);

    return (
        <section
            className={styles.experienceSection}
            id="experience"
            data-theme={theme}
        >
            <div className="container">
                <h2 className="section-title">Professional Experience</h2>

                <div className={styles.experienceTimeline}>
                    {experienceData.map((job, index) => (
                        <div key={index} className={styles.experienceItem}>
                            <div className={styles.experienceHeader}>
                                <h3 className={styles.experienceTitle}>{job.title}</h3>
                                <span className={styles.experienceCompany}>{job.company}</span>
                                <span className={styles.experiencePeriod}>{job.period}</span>
                            </div>

                            <ul className={styles.experienceResponsibilities}>
                                {job.responsibilities.map((responsibility, respIndex) => (
                                    <li key={respIndex}>{responsibility}</li>
                                ))}
                            </ul>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
}

export default Experience;